import React, { useState, useEffect } from 'react';
import Layout from '../../components/layout/Layout';
import comprobanteService from '../../services/comprobanteService';
import { formatearMoneda, formatearFecha } from '../../utils/helpers';
import { FaFileInvoice, FaCheck, FaTimes, FaClock, FaEye } from 'react-icons/fa';

const API_BASE = 'https://sistemafinanciero.digitaleseduproperu.com/api';
const ESTADOS  = ['pendiente', 'activo', 'anulado'];

export default function ComprobantesContadorPage() {
  const [comprobantes, setComprobantes] = useState([]);
  const [cargando,     setCargando]     = useState(true);
  const [filtroEstado, setFiltroEstado] = useState('');
  const [vistaPrevia,  setVistaPrevia]  = useState(null);

  useEffect(() => { cargarDatos(); }, []);

  const cargarDatos = async () => {
    setCargando(true);
    try {
      const data = await comprobanteService.listarContador();
      setComprobantes(data || []);
    } finally {
      setCargando(false);
    }
  };

  const handleCambiarEstado = async (id, estado) => {
    await comprobanteService.cambiarEstado(id, estado);
    cargarDatos();
  };

  const handleVerArchivo = (c) => {
    if (!c.archivo_url) return;
    const token = localStorage.getItem('token');
    const filename = c.archivo_url.replace('comprobantes/', '');
    const url = `${API_BASE}/archivos/${filename}?token=${token}`;
    setVistaPrevia({ url, titulo: `${c.tipo?.toUpperCase()} ${c.serie}-${c.numero_comprobante}` });
  };

  const filtrados = comprobantes.filter((c) =>
    !filtroEstado || c.estado === filtroEstado
  );

  const getIconEstado = (estado) => {
    const iconos = {
      activo:    <FaCheck color="#27AE60" />,
      anulado:   <FaTimes color="#E74C3C" />,
      pendiente: <FaClock color="#F39C12" />,
    };
    return iconos[estado] || null;
  };

  return (
    <Layout>
      {vistaPrevia && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.7)', zIndex:9999, display:'flex', alignItems:'center', justifyContent:'center' }}>
          <div style={{ background:'#fff', borderRadius:12, width:'80vw', height:'85vh', display:'flex', flexDirection:'column', overflow:'hidden', boxShadow:'0 20px 60px rgba(0,0,0,0.4)' }}>
            <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'14px 20px', background:'#001B5C', color:'#fff' }}>
              <span style={{ fontWeight:700, fontSize:14 }}>{vistaPrevia.titulo}</span>
              <div style={{ display:'flex', gap:10 }}>
                <a href={vistaPrevia.url} target="_blank" rel="noreferrer" style={{ background:'#FF7A00', color:'#fff', borderRadius:6, padding:'6px 14px', fontSize:12, fontWeight:600, textDecoration:'none' }}>
                  Abrir en nueva pestaña
                </a>
                <button onClick={() => setVistaPrevia(null)} style={{ background:'rgba(255,255,255,0.15)', color:'#fff', border:'none', borderRadius:6, padding:'6px 12px', cursor:'pointer', fontSize:16, fontWeight:700 }}>
                  ✕
                </button>
              </div>
            </div>
            <iframe src={vistaPrevia.url} style={{ flex:1, border:'none', width:'100%' }} title="Vista previa comprobante" />
          </div>
        </div>
      )}

      <div className="page-header d-flex justify-content-between align-items-center">
        <div>
          <h4>Comprobantes del Contador</h4>
          <p>Revisión y aprobación de comprobantes registrados</p>
        </div>
        <select className="form-select form-select-sm w-auto" value={filtroEstado} onChange={(e) => setFiltroEstado(e.target.value)}>
          <option value="">Todos los estados</option>
          {ESTADOS.map((e) => <option key={e} value={e}>{e}</option>)}
        </select>
      </div>

      <div className="card card-custom">
        <div className="card-body">
          {cargando ? (
            <div className="text-center py-4"><div className="spinner-custom mx-auto" /></div>
          ) : (
            <div className="table-responsive">
              <table className="table table-custom">
                <thead>
                  <tr>
                    <th>Serie/N°</th>
                    <th>Tipo</th>
                    <th>Monto</th>
                    <th>Fecha</th>
                    <th>Estado</th>
                    <th>Archivo</th>
                    <th>Cambiar Estado</th>
                  </tr>
                </thead>
                <tbody>
                  {filtrados.length > 0 ? filtrados.map((c) => (
                    <tr key={c.id}>
                      <td className="fw-bold">{c.serie}-{c.numero_comprobante || '—'}</td>
                      <td><span className="badge bg-secondary">{c.tipo}</span></td>
                      <td className="fw-bold">{formatearMoneda(c.monto_total)}</td>
                      <td>{formatearFecha(c.fecha_emision)}</td>
                      <td>
                        <span className="d-flex align-items-center gap-1">
                          {getIconEstado(c.estado)}
                          <span className={`badge ${c.estado === 'activo' ? 'badge-activo' : c.estado === 'anulado' ? 'badge-anulado' : 'badge-pendiente'}`}>
                            {c.estado}
                          </span>
                        </span>
                      </td>
                      <td>
                        {c.archivo_url ? (
                          <button onClick={() => handleVerArchivo(c)} style={{ background:'#001B5C', color:'#fff', border:'none', borderRadius:6, padding:'5px 10px', fontSize:11, fontWeight:600, cursor:'pointer', display:'flex', alignItems:'center', gap:4 }}>
                            <FaEye size={11} /> Ver
                          </button>
                        ) : (
                          <span style={{ fontSize:11, color:'#CBD5E1' }}>Sin archivo</span>
                        )}
                      </td>
                      <td>
                        <div className="d-flex gap-1">
                          {ESTADOS.filter((e) => e !== c.estado).map((e) => (
                            <button key={e} className={`btn btn-sm ${e === 'activo' ? 'btn-outline-success' : e === 'anulado' ? 'btn-outline-danger' : 'btn-outline-warning'}`} onClick={() => handleCambiarEstado(c.id, e)}>
                              {e}
                            </button>
                          ))}
                        </div>
                      </td>
                    </tr>
                  )) : (
                    <tr>
                      <td colSpan="7" className="text-center text-muted py-4">
                        <FaFileInvoice size={32} className="mb-2 d-block mx-auto" />
                        Sin comprobantes del contador
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
}
